import React from 'react';
import {
  Avatar
} from '@material-ui/core';
import AvatarHoc from './AvatarHoc';

export default function Default(props) {
  return (
    <AvatarHoc
      Component={Avatar}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/widgets/Avatar/Variant/Default.jsx